import React from 'react'
import classNames from 'classnames'

import styles from './styles.module.scss'

import type { SubheaderProps } from './types'

export const Subheader: React.FC<SubheaderProps> = ({
  className: outerClassName,
  toolbarClassName: outerToolbarClassName,
  toolbar,
  control
}) => {
  const className = classNames(styles.subheader, outerClassName)
  const toolbarClassName = classNames(outerToolbarClassName, styles.subheader__toolbar)

  return (
    <header className={ className }>
      <div>{ control }</div>

      <div className={ toolbarClassName }>{ toolbar }</div>
    </header>
  )
}
